import {DialogContent, styled, TableHead} from "@mui/material";

export const AddProductDialogContent = styled(DialogContent)(() => ({
    display: 'flex',
    flexDirection: 'column',
    gap: '1rem',
}));

export const ActionDialogOrderListHeader = styled(TableHead)(() => ({
    '&.MuiTableHead-root': {
        backgroundColor: '#F1F1FB',
        height: '3.1rem',
        padding: '1rem 0.75rem',
    },

    '& .MuiTableRow-root:hover': {
        backgroundColor: '#F1F1FB',
    },
}));
